<script>
/**
 * Sales Analytics component
 */
export default {
  props: {
    statistics: { type: Object },
  },
  computed: {
    meses() {
      const nomes = [
        'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
        'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'
      ];
      const mesAtual = new Date().getMonth();
      const lista = [];
      for (let i = mesAtual; i >= 0; i--) {
        lista.push({ value: i + 1, label: nomes[i] });
      }
      return lista;
    },
  },
  data() {
    return {
      selectedMonth: new Date().getMonth() + 1,
      series: [],
      chartOptions: {
        chart: {
          height: 230,
          type: "donut"
        },
        labels: [],
        plotOptions: {
          pie: {
            donut: {
              size: "75%"
            }
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        colors: ["#5664d2", "#1cbb8c", "#eeb902"]
      },
      terapias: []
    };
  },
  mounted() {
    this.loadMonth(this.selectedMonth);
  },
  watch: {
    selectedMonth(mes) {
      this.loadMonth(mes);
    },
  },
  methods: {
    loadMonth(mes) {
      const dados = this.statistics.analiseTerapias[mes] || [];
      if (!dados.length) {
        this.series = [];
        this.chartOptions = { ...this.chartOptions, labels: [] };
        this.terapias = [];
        return;
      }
      this.series = dados.map(t => t.total);
      this.chartOptions = { ...this.chartOptions, labels: dados.map(t => t.specialty_name) };
      const sumTotal = dados.reduce((acc, curr) => acc + curr.total, 0);
      this.terapias = dados.map((terapia, index) => ({
        percent: Math.round((terapia.total * 100) / sumTotal),
        id: terapia.specialty_id,
        nome: terapia.specialty_name,
        color: this.chartOptions.colors[index]
      }));
    },
  }
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <div class="float-right">
        <select id="select-mes-sales-analytics" v-model="selectedMonth" class="custom-select custom-select-sm">
          <option v-for="mes in meses" :key="mes.value" :value="mes.value">{{ mes.label }}</option>
        </select>
      </div>
      <h4 class="card-title mb-4">Análise Serviços</h4>

      <div id="donut-chart" class="apex-charts"></div>
      <apexchart
        class="apex-charts"
        height="230"
        dir="ltr"
        :series="series"
        :options="chartOptions"
      ></apexchart>
      <div class="row">
        <div class="col-4" v-for="terapia in terapias" :key="terapia.id">
          <div class="text-center mt-4">
            <p class="mb-2 text-truncate" style="font-size: 11px;" :title="terapia.nome">
              <i class="mdi mdi-circle font-size-10 mr-1" :style="{ color: terapia.color }"></i> {{terapia.nome}}
            </p>
            <h5>{{terapia.percent}} %</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>